export function matchesSearchText(
  candidates: (string | undefined)[],
  query: string
): boolean {
  const lower = query.toLowerCase();
  return candidates.some((c) => c?.toLowerCase().includes(lower));
}
